import { UnitTypes } from '@/domain/units/UnitTypes.enum';
import { RefmodelTypes } from '@/domain/refmodels/RefmodelTypes.enum';
import { PointTypes } from '@/domain/point/PointTypes.enum';
import { PointSetType } from '@/domain/pointSet/PointSetType';
import { SurfacelogType } from '@/domain/surfacelog/SurfacelogType';
import { AwarenessEventType } from '@/domain/awareness/AwarenessEventType';
import { AwarenessEventSetType } from '@/domain/awareness/AwarenessEventSetType';


const filterPanelTypes = {
  dashboard: 'dashboardView',
  unit: 'CxFilterUnitView',
  measurePoint: 'CxAsBuiltFilterContainer',
  refModel: 'CxFilterRefModelView',
  awarenessEvent: 'CxFilterAwarenessEventView'
};

const filterPointPanelTypes = {
  point: 'CxMeasuredPointFilters',
  surface: 'CxSurfaceFilters'
};

const detailsPanelTypes = {
  unit: 'CxUnitDetailsPanel',
  point: 'CxMeasuredPointDetailsPanel',
  refModel: 'CxRefModelDetailsPanel',
  pointSet: 'CxPointSetDetailsPanel',
  awarenessEventSet: 'CxAwarenessEventSetDetailsPanel',
  awarenessEvent: 'CxAwarenessEventDetailsPanel',
  surfaceLog: 'CxSurfaceLogDetailsPanel'
};

const shellStoreModule = {
  state: {
    isFilterPanelOpened: false,
    isDetailsPanelOpened: false,
    isObjectExplorerOpened: false,
    filterPanelContent: null,
    detailsPanelType: null,
    isDetailsPanelReduced: false,
    filterPointPanelContent: null,
    animationSwitch: {
      isFilterPanelTransitions: true,
      isDetailsPanelTransitions: true,
      isObjectExplorerTransitions: true,
      isAvatarTransitions: true,
      isLegendTransitions: true,
      isDirectSearchTransitions: true,
      isMapToolbarTransitions: true
    }
  },
  getters: {
    isFilterPanelOpened(state) {
      return state.isFilterPanelOpened;
    },
    isDetailsPanelOpened(state) { // should be only a getter and be synced with selected entity
      return state.isDetailsPanelOpened;
    },
    isObjectExplorerOpened(state) {
      return state.isObjectExplorerOpened;
    },
    filterPanelContent(state) {
      return state.filterPanelContent;
    },
    detailsPanelType(state) {
      return state.detailsPanelType;
    },
    isDetailsPanelReduced(state) {
      return state.isDetailsPanelReduced;
    },
    filterPointPanelContent(state) {
      return state.filterPointPanelContent;
    },
    animationSwitch(state) {
      return state.animationSwitch;
    }
  },
  mutations: {
    setIsFilterPanelOpened(state, isOpened) {
      state.isFilterPanelOpened = isOpened;
    },
    setFilterPanelContent(state, content) {
      state.filterPanelContent = content;
    },
    setIsDetailsPanelOpened(state, isOpened) {
      state.isDetailsPanelOpened = isOpened;
    },
    setIsObjectExplorerOpened(state, payload) {
      state.isObjectExplorerOpened = payload;
    },
    setDetailsPanelType(state, type) {
      state.detailsPanelType = type;
    },
    setIsDetailsPanelReduced(state, isReduced) {
      state.isDetailsPanelReduced = isReduced;
    },
    setFilterPointPanelContent(state, content) {
      state.filterPointPanelContent = content;
    },
    setUseAnimations(state, useAnimations) {
      const entries = Object.entries(state.animationSwitch);
      entries.forEach((a) => { a[1] = useAnimations; });
      state.animationSwitch = Object.fromEntries(entries);
    }
  },
  actions: {
    async notifyMapMounted() {
      // console.log('map placehoder ready');
    },
    async changeFilterContent(context, activeFilter) {
      if (context.getters.isFilterPanelOpened && context.getters.filterPanelContent === activeFilter) {
        context.commit('setIsFilterPanelOpened', false);
        context.commit('setFilterPanelContent', null);
      } else {
        context.commit('setIsFilterPanelOpened', true);
        context.commit('setFilterPanelContent', activeFilter);
      }
    },
    async changeDetailsPanelType(context, { selectedEntity }) {
      if (selectedEntity) {
        context.commit('setIsDetailsPanelOpened', true);
        const { entityType } = selectedEntity;
        if (Object.values(UnitTypes).includes(entityType)) context.commit('setDetailsPanelType', detailsPanelTypes.unit);
        else if (Object.values(RefmodelTypes).includes(entityType)) context.commit('setDetailsPanelType', detailsPanelTypes.refModel);
        else if (Object.values(PointTypes).includes(entityType)) context.commit('setDetailsPanelType', detailsPanelTypes.point);
        else if (entityType === PointSetType) context.commit('setDetailsPanelType', detailsPanelTypes.pointSet);
        else if (entityType === AwarenessEventSetType) context.commit('setDetailsPanelType', detailsPanelTypes.awarenessEventSet);
        else if (entityType === AwarenessEventType) context.commit('setDetailsPanelType', detailsPanelTypes.awarenessEvent);
        else if (entityType === SurfacelogType) context.commit('setDetailsPanelType', detailsPanelTypes.surfaceLog);
        else context.commit('setDetailsPanelType', null);
      } else {
        // nothing is selected
        context.commit('setIsDetailsPanelOpened', false);
        context.commit('setDetailsPanelType', null);
      }
    },
    async initializeFilteringPanel(context) {
      const component = filterPointPanelTypes.point;
      context.commit('setFilterPointPanelContent', component);
    },
    async handleEntitySelection(context, selectedEntity) {
      const { newValue } = selectedEntity;
      if (!newValue) {
        context.commit('setIsDetailsPanelOpened', false);
      }
      context.commit('setIsFilterPanelOpened', false);
      context.commit('setIsDetailsPanelOpened', false);
      context.dispatch('changeDetailsPanelType', { selectedEntity: newValue });
    },
  }
};

export { shellStoreModule, filterPanelTypes, filterPointPanelTypes, detailsPanelTypes };